import { type Components, type ScrollerProps } from 'react-virtuoso';
import styles from './list-components.module.scss';

export const Scroller: Components<any, any>['Scroller'] = (props) => {
  const { style, ref, ...rest } = props as ScrollerProps;
  return <div {...rest} ref={ref} style={style} className={styles.scroll} />;
};
